module.exports = __webpack_public_path__ + "static/img/fullscreen.691be2cb.svg";